export const LOCATE_INV_DEV = {
  name: 'Dev',
  url: 'https://test-repeaterstore.locateinv.com'
};
export const LOCATE_INV_PROD = {
  name: 'Prod',
  url: 'https://repeaterstore.locateinv.com'
};
